import { DropDownBox } from './DropDownBox';
import { useState, useEffect } from 'react';
import { countyList } from '@apply/constants';

interface CountyDropDownProps {
    id: string;
    value: string;
    label: string;
    helperText?: string;
    required?: boolean;
    placeholder?: string;
    width?: string;
    selectedState?: string;
    readOnly?: boolean;
    onChange: (value: string) => void;
    validator?: React.ReactNode;
    showInfoIcon?: boolean;
    infoText?: string;
}

export const CountyDropDown: React.FC<CountyDropDownProps> = ({
    id,
    value,
    label,
    helperText,
    required = false,
    placeholder,
    width,
    selectedState,
    readOnly = false,
    onChange,
    validator,
    showInfoIcon = false,
    infoText,
}) => {
    const [countySelectList, setCountySelectList] = useState<{ value: string; display: string }[]>();

    useEffect(() => {
        const tempCountyList = countyList
            .filter((county) => county.state === selectedState)
            .map((county) => {
                return { display: county.county, value: county.county };
            });
        tempCountyList.unshift({ display: '', value: '' });
        setCountySelectList(tempCountyList);
    }, [selectedState]);

    return (
        <DropDownBox
            id={id}
            value={value}
            onChange={onChange}
            label={label}
            helperText={helperText}
            required={required}
            dataSource={countySelectList}
            placeholder={placeholder}
            width={width}
            valueExpr='value'
            displayExpr='display'
            readOnly={readOnly}
            validator={validator}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
        />
    );
};
